{
  "processing": "Memproses verifikasi...",
  "loadingIframe": "Memuat verifikasi ID...",
  "issueTitle": "Masalah Verifikasi ID",
  "notConfigured": "Verifikasi ID tidak dikonfigurasi dengan benar untuk gudang ini.",
  "notSuccessful": "Verifikasi ID tidak berhasil. Silakan coba lagi atau hubungi gudang.",
  "couldNotCompleteProceed": "Verifikasi ID tidak dapat diselesaikan, tetapi Anda dapat melanjutkan check-in.",
  "processFailed": "Gagal memproses verifikasi ID. Silakan coba lagi.",
  "processingFailedProceed": "Pemrosesan verifikasi ID gagal, tetapi Anda dapat melanjutkan check-in.",
  "genericError": "Terjadi kesalahan saat verifikasi ID. Silakan coba lagi.",
  "issueProceed": "Verifikasi ID mengalami masalah, tetapi Anda dapat melanjutkan check-in.",
  "requiredTryAgain": "Verifikasi ID diperlukan untuk menyelesaikan check-in. Silakan coba lagi.",
  "checkInFailedTitle": "Tidak dapat check-in",
  "checkInFailedMessage": "ID Anda tidak dapat divalidasi"
}
